import { useQuery } from '@tanstack/react-query';

import services from '@/services';

export const useStatusesQuery = () => {
   return useQuery({
      queryKey: ['statuses'],
      queryFn: async () => {
         const response = await services.status.getStatuses();
         return response.data;
      },
   });
};
